import React, { Component } from 'react';
import { asyncComponent } from 'react-async-component';

const EmbedMarketing = asyncComponent({
  resolve: () => import('./EmbedMarketing'),
});

export default class EmbedMarketingWrapper extends Component {
  render() {
    return(
      <div>
        <EmbedMarketing config={this.props.config}/>
      </div>
    );
  }
}

EmbedMarketingWrapper.propTypes = {
};
